<style>
	.listview-div {
		height: 21px;
		padding: .7em 1em;
		color: #666;
		text-decoration: none;
		margin-top: 1em;
		background-color: white;
		position: relative;
	}
	.excel-button {
		position: absolute !important;
		top:50%;
		right:10px;
		transform: translateY(-50%);
	}
</style>

<template>
<div class="edi-accounts" :style="{ 'height': deviceHeight }">
	<div class='listview-div'>
		"同意"餐企订单同时发送Excel到绑定邮箱
		<wa-switch @change = "excelChange" class="excel-button" v-model="excelFlag"></wa-switch>
	</div>
	<div class='listview-div'>
		允许餐企撤销订货单
		<wa-switch @change="cancelFlagChange" class="excel-button" v-model="cancelFlag"></wa-switch>
	</div>
	<div class="listview-div">
		允许餐企发货后撤销订货单
		<wa-switch @change="sendCancelChange" class="excel-button" v-model="sendCancelFlag"></wa-switch>
	</div>
	<div class="listview-div">
		订单显示金额
		<wa-switch @change="moneyChange" class="excel-button" v-model="moneyFlag"></wa-switch>
	</div>
	<div class="listview-div">
		订单显示发货实收数量
		<wa-switch @change="actualNumChange" class="excel-button" v-model="actualNumFlag"></wa-switch>
	</div>
	<div class="listview-div">
		订单显示辅助单位和数量
		<wa-switch @change="actualAssistNumChange" class="excel-button" v-model="actualAssistNumFlag"></wa-switch>
	</div>
	<div class="listview-div">
		订单显示品项编号
		<wa-switch @change="itemCodeChange" class="excel-button" v-model="itemCodeFlag"></wa-switch>
	</div>
	<div class="listview-div">
		订单分享显示仓库
		<wa-switch @change="itemShowHouseChange" class="excel-button" v-model="itemShowShareHouseFlag"></wa-switch>
	</div>
	<loading v-show="loading"></loading>
	<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
</div>
</template>
<script>
import Loading from '../components/loading'
import TipsAuto from '../components/TipsAuto'
import Switch from '../components/Switch'
export default {
	data () {
		return {
			tipsauto: false,
			tipsFont: '',
			sec: 1500,
			loading: true,
			deviceHeight: this.$root.deviceHeight,
			transitionName: 'page-next',
			accountInfo: {},
			excelFlag: false,
			cancelFlag: false,
			sendCancelFlag: false,
			moneyFlag: true,
			actualNumFlag: true,
			actualAssistNumFlag: true,
			itemShowShareHouseFlag: true,
			itemCodeFlag: true
		}
	},
	components: {
		'loading': Loading,
		'tips-auto': TipsAuto,
		'wa-switch': Switch
	},
	created () {
		this.getExcelFlag()
	},
	methods: {
		excelChange (currentValue) {
			this.excelFlag = currentValue
			this.setSysParameter({sysparameter: currentValue})
		},
		cancelFlagChange (currentValue) {
			this.cancelFlag = currentValue
			var postData = {
				revoke_order_bill: currentValue
			}
			if (!currentValue) {
				postData.sendOutRevokeBill = false
			}
			this.setSysParameter(postData)
		},
		sendCancelChange (currentValue) {
			this.sendCancelFlag = currentValue
			var postData = {
				sendOutRevokeBill: currentValue
			}
			if (currentValue) {
				postData.revoke_order_bill = true
			}
			this.setSysParameter(postData)
		},
		moneyChange (currentValue) {
			this.moneyFlag = currentValue
			this.setSysParameter({order_show_money_flag: currentValue})
		},
		actualNumChange (currentValue) {
			this.actualNumFlag = currentValue
			this.setSysParameter({ order_show_sendrealnum_flag: currentValue })
		},
		actualAssistNumChange (currentValue) {
			this.actualAssistNumFlag = currentValue
			this.setSysParameter({ order_show_assistnum_flag: currentValue })
		},
		itemCodeChange (currentValue) {
			this.itemCodeFlag = currentValue
			this.setSysParameter({ order_show_itemcode_flag: currentValue })
		},
		itemShowHouseChange (currentValue) {
			this.itemShowShareHouseFlag = currentValue
			this.setSysParameter({ order_show_sharehouse_flag: currentValue })
		},
		getExcelFlag () {
			this.loading = true
			this.$http.post('/cldEdi/business/getSysParameter').then((response) => {
				this.loading = false
				let data = response.body
				if (data.result) {
					// var reqdata = data.data
					// reqdata.sendOutRevokeBill = parseInt(data.data.sendOutRevokeBill)
					let {
						sysparameter: excelFlag = 0,
						revoke_order_bill: cancelFlag = false,
						sendOutRevokeBill: sendCancelFlag = false,
						order_show_money_flag: moneyFlag = true,
						order_show_sendrealnum_flag: actualNumFlag = true,
						order_show_assistnum_flag: actualAssistNumFlag = true,
						order_show_itemcode_flag: itemCodeFlag = true,
						order_show_sharehouse_flag: itemShowShareHouseFlag = true
					} = data.data
					this.excelFlag = !(excelFlag === 0)
					this.cancelFlag = cancelFlag
					this.sendCancelFlag = sendCancelFlag
					this.moneyFlag = moneyFlag
					this.actualNumFlag = actualNumFlag
					this.actualAssistNumFlag = actualAssistNumFlag
					this.itemCodeFlag = itemCodeFlag
					this.itemShowShareHouseFlag = itemShowShareHouseFlag
				} else {
					this.autoTips(data.message)
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请试！')
			})
		},
		setSysParameter (postData) {
			this.loading = true
			for (let attr in postData) {
				postData[attr] = postData[attr] ? '1' : '0'
			}
			this.$http.post('/cldEdi/business/updateSysParameter', postData).then((response) => {
				this.loading = false
				let data = response.body
				if (data.result) {
					// var reqdata = data.data
					// reqdata.sendOutRevokeBill = parseInt(data.data.sendOutRevokeBill)
					let {sysparameter: excelFlag = 0, revoke_order_bill: cancelFlag = false, sendOutRevokeBill: sendCancelFlag = false} = data.data
					this.excelFlag = !(excelFlag === 0)
					this.cancelFlag = cancelFlag
					this.sendCancelFlag = sendCancelFlag
					this.autoTips('设置成功')
				} else {
					this.autoTips(data.message)
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务请求失败，稍后请重试！')
			})
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		}
	}
}
</script>



// WEBPACK FOOTER //
// SystemParameter.vue?097be8e8